  window.addEventListener('DOMContentLoaded', () => {
    const variantsJSONSRC = document.getElementById('product-variants-data');
    if(!variantsJSONSRC) return;

    const variantsJson = variantsJSONSRC.textContent;
    const variantsData = JSON.parse(variantsJson);
    
    if(!variantsData) return;
    
    const variantSelectors = Array.from(document.querySelectorAll('.product-badge-toggler'));
    const colorSelectors = Array.from(document.querySelectorAll('.product-badge-toggler.selector-color'));
    const variantBadges = Array.from(document.querySelectorAll('.variant-quantity-badge'));
    const atcLabel = document.querySelector('.product-button-pricing__label');

    if(!variantSelectors || !variantBadges) return;

    variantSelectors.forEach(selector => {
      selector.addEventListener('change', event => {
        toggleBadges();
      })
    });

    toggleBadges();

    function toggleBadges() {
      const selectedVariantName = variantSelectors.filter(item => item.checked).map(item => item.getAttribute('value')).join(' / ');
      const selectedVariantID = variantsData.filter(item => item.title === selectedVariantName).map(item => item.id);
      
      const badgeSelector = `.variant-quantity-badge[data-variant-id="${selectedVariantID}"]`;
      const currentBadge = document.querySelector(badgeSelector);

      variantBadges.forEach(badge => badge.setAttribute('data-enabled', false));
      currentBadge.setAttribute('data-enabled', true);

      const variantAvailable = variantsData.filter(item => item.id === selectedVariantID[0]).map(item => item.available);
      if(atcLabel) {
        if(variantAvailable[0]) {
          atcLabel.innerHTML = "Dodaj u korpu"
        }else {
          atcLabel.innerHTML = "RASPRODATO"
        }
      }
    }

    function toggleColorSelectors(input) {
      console.log("Input: ", input)
      const quantityData = input.getAttribute('data-variant-quantity')
      
      if(!quantityData) return;

      const variantQuantity = quantityData.split(',');

      if(!colorSelectors) return;
      colorSelectors.forEach(color => {
        color.disabled = false
        color.classList.remove('disabled')
      })

      variantQuantity.forEach(quantity => {
        if(quantity > 0) return;

        const index = variantQuantity.indexOf(quantity);

        colorSelectors[index].classList.add('disabled');
      })
    }
  })